<template>
    <div>
        <li>
            <div class="d-flex justify-space-between">
                <div>
                    {{ title }} :
                    <span
                        :class="{
                            'grey-text': !configurationText,
                            'font-weight-bold' : configurationText
                        }"
                    >
                        {{ configurationText }}
                    </span>
                </div>
                <div>
                    <a
                        href="#"
                        class="text-decoration-underline habiteo-body-2"
                        @click.prevent="gotToStep(stepIndex + 1)"
                    >
                        {{ $t('utils.modify') }}
                    </a>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
    export default {
        name: 'StepConfigurationItem',
        props: {
            selectedValue: {
                type: [Number, Boolean],
                required: false
            },
            inputs: {
                type: Array,
                required: true
            },
            stepIndex: {
                type: Number,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                summary: true,
                configurationText: null
            }
        },
        mounted() {
            this.$props.inputs.forEach(input => {
                input.fields.forEach(field => {
                    if (field.value === this.$props.selectedValue)
                        this.configurationText = field.label;
                });
            });
        },
        methods: {
            gotToStep(step) {
                this.$emit('select-step', step);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepConfigurationItem.vue